module.exports = __webpack_public_path__ + "static/media/10C.354b7b1e.jpg";